import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["oidcFields", "samlFields", "protocolSelect"]

  connect() {
    this.toggle()
  }

  toggle() {
    const protocol = this.protocolSelectTarget.value

    if (this.hasOidcFieldsTarget) {
      this.oidcFieldsTarget.style.display = protocol === "oidc" ? "block" : "none"
    }

    if (this.hasSamlFieldsTarget) {
      this.samlFieldsTarget.style.display = protocol === "saml" ? "block" : "none"
    }
  }

  copyUrl(event) {
    const url = event.currentTarget.dataset.ssoSettingsCopyValue
    if (url) {
      navigator.clipboard.writeText(url)
    }
  }
}
